var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button yellow action-btn",attrs:{"href":_vm.url,"target":"_blank","title":_vm.$t('login')}},[_c('img',{staticClass:"action-icon",attrs:{"src":require("@/assets/voir-session.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }